module.exports = __webpack_public_path__ + "img/support-question.e11889d2.png";